import { createSelector } from 'reselect';
import { RootState } from 'store';

export const selectQuizEvents = (state:RootState) => state.quizEvent.quizEvents;

export const selectQuizEventsAsOptions = createSelector(
  [selectQuizEvents],
  (quizEvents) => {
    if (!quizEvents) return [];
    return quizEvents.map(event => ({
      value: event._id,
      label: event.name,
    }));
  }
);
